export const notificationSuccessText = 'Ссылка скопирована в буфер обмена';
export const notificationErrorText = 'Попробуйте ещё раз или обновите страницу';
